import React, { useEffect } from "react";
import { ClipLoader } from "react-spinners";
import { getAllBlogs } from "services/BlogService";
import { getJWT } from "services/TokenService";
import { getUserId } from "services/TokenService";

export const BlogPosts = () => {
  const [blogs, setBlogs] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  const userid = getUserId();
  const token = getJWT();
  const loggedin =
    userid != undefined && userid != null && token != undefined && token != null
      ? true
      : false;

  const adminLevel = loggedin && (userid == 1 || userid == 2)
  useEffect(() => {
    getAllBlogs()
      .then((res) => {
        if (loggedin) {
          setBlogs(res.data?.data || []);
        } else {
          console.log(res)
          const viewableBlogs = res.data?.data?.filter(
            (blog) => !blog.archived
          ) || [];

          setBlogs(viewableBlogs);
        }
      })
      .finally(() => setLoading(false));
  }, []);
  if (loading) {
    return (
      <div className="w-90 mx-auto mt-5-vh" style={{ textAlign: "center" }}>
        <ClipLoader color="blue" className="loader" />
      </div>
    );
  }

  return (
    <div className="w-90 mx-auto mt-5-vh" style={{ minHeight: "50vh" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h2 className="blue mb-4">Blog Posts</h2>
        {adminLevel && (
          <a href="/user/blogs/create" className="btn btn-primary p-2">
            Add Blog
          </a>
        )}
      </div>
      {blogs.length === 0 ? (
        <div className="text-center text-muted" style={{ marginTop: "40px" }}>
          No blog is yet added.
        </div>
      ) : (
        <div
          className="blog-grid"
          style={{ display: "flex", flexWrap: "wrap", gap: "24px" }}
        >
          {blogs.map((blog, idx) => (
            <div
              key={blog.id}
              className={`blog-card bg-white p-3 shadow${blog.archived ? " blog-archived" : ""}`}
              style={{
                flex: "1 1 calc(33.333% - 24px)",
                maxWidth: "calc(33.333% - 24px)",
                boxSizing: "border-box",
                marginBottom: "24px",
                opacity: blog.archived ? 0.6 : 1,
                border: blog.archived ? "2px solid #f39c12" : undefined,
                position: "relative",
              }}
            >
              {blog.archived && (
                <div
                  style={{
                    position: "absolute",
                    top: "12px",
                    right: "12px",
                    background: "#f39c12",
                    color: "#fff",
                    padding: "4px 10px",
                    borderRadius: "4px",
                    fontWeight: "bold",
                    fontSize: "0.85em",
                    zIndex: 2,
                  }}
                >
                  Archived
                </div>
              )}
              <img
                src={blog.image}
                alt={blog.title}
                style={{
                  width: "100%",
                  height: "180px",
                  objectFit: "cover",
                  borderRadius: "8px",
                  filter: blog.archived ? "grayscale(60%)" : "none",
                }}
              />
              <h3 className="blue mt-2">{blog.title}</h3>
              <p className="text-muted" style={{ fontSize: "0.9em" }}>
                {blog.date}
              </p>
              <p>{blog.summary}</p>
              <a
                href={`/user/blogs/${blog.slug}`}
                className="btn btn-primary mt-2"
                style={{ display: "inline-block", textDecoration: "none" }}
              >
                Read More
              </a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BlogPosts;
